import { Client } from "@/redux/slices/client/types";
import { ClientsOptions } from "@/redux/slices/client/types";
import { GetClientOptionsRawResponse, GetClientsRawResponse, GetClientsResponse } from "./types";

export const transformClients = (res: GetClientsRawResponse) => {
  const { page, page_count, page_size, total_items } = res;
  // HAL omits `_embedded` entirely when there are 0 results — default to [] so an
  // empty result clears the table (empty state) instead of throwing and leaving stale rows.
  const clients = res._embedded?.client ?? [];

  const response: GetClientsResponse = {
    data: {
      clients: clients.map(
        (i) =>
          ({
            id: i.uuid,
            name: i.name,
            email: i.email,
            pendingEmail: i.pending_email,
            phone: i.phone,
            companyId: i.company?.uuid,
            companyName: i.company?.name,
            accountType: i.account_type,
            hearAboutUs: i.hear_about_us,
            status: i.status,
            joined: i.join_date,
            paymentMethod: i.payment_method ?? null,
            madeBooking: i.made_booking ?? false,
            isVip: i.is_vip ?? false,
            operatorIdentifier: i.identifier ?? "",
          } as Client)
      ),
      page: {
        current: page,
        count: page_count,
        size: page_size,
        total: total_items,
      },
    },
  };

  return response;
};

export const transformClientOptions = (res: GetClientOptionsRawResponse) => {
  const { status, account_type } = res;

  const response: ClientsOptions = {
    statuses: Object.entries(status).map((i) => ({ name: i[1], value: i[0] })),
    types: Object.entries(account_type).map((i) => ({ name: i[1], value: i[0] })),
  };

  return response;
};
